export class Global {
  public show: any = {};
  public step: number = 0;
  public alertOptions: any = {};
  public errors: any = {};

  constructor() {}

  public toggle(key) {
    this.show[key] = !this.show[key];
  }

  public startLoading() {
    this.show['loading'] = true;
  }

  public endLoading() {
    this.show['loading'] = false;
  }

  public checkStep(step: number): boolean {
    return this.step === step;
  }

  public next() {
    this.step++;
  }

  public prev() {
    this.step--;
  }

  public getNOK(ore: number) {
    if (ore) {
      return ore / 100;
    }

    return 0;
  }

  public getOre(nok: number) {
    if (nok) {
      return nok * 100;
    }
    return 0;
  }

  public generateFilterString(params: any) {
    let filterString: string = '';

    for (const key in params) {
      if (params[key]) {
        filterString += `${key}=${params[key]}&`;
      }
    }
    filterString = filterString.slice(0, -1);

    return filterString;
  }

  // Forms
  // -------------------------
  public checkInvalid(uc: any = {}, key: string, force: boolean) {
    if (!uc[key]) {
      return false;
    }

    return !(uc[key].valid || uc[key].pristine) || (force && !uc[key].valid);
  }

  public convertDate(dateString: string): Date {
    return new Date(dateString);
  }

  public getAge(dateString) {
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  public timeSince(d: string, future?: boolean) {
    const date = +new Date(d);

    let seconds = Math.floor((+new Date() - date) / 1000);

    if (future) {
      seconds = seconds * -1;
    }

    let interval = Math.floor(seconds / 31536000);

    if (interval >= 1) {
      return interval + ' år';
    }

    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      return interval + ' måneder';
    }

    interval = Math.floor(seconds / 86400);
    if (interval >= 1) {
      return interval + ' dager';
    }

    interval = Math.floor(seconds / 3600);
    if (interval >= 1) {
      return interval + ' timer';
    }

    interval = Math.floor(seconds / 60);
    if (interval >= 1) {
      return interval + ' minutter';
    }
    return 'Bare noen sekunder  ';
  }
}
